import React from 'react';
import { Route } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';

export default (props) => (
  <Route
    path={props.to}
    exact
    children={({ match, history }) => (
      <Menu.Item
        onClick={(e) => history.push(e.currentTarget.getAttribute('to'))}
        {...props}
        active={!!match}
      >
        {props.children}
      </Menu.Item>
    )}
  />
);
